import React, { createElement } from 'react'
import { cx } from '@emotion/css'
import NavDropdown, { DropdownButton, DropdownLink } from '../NavDropdown'
import NavigationLink from '../NavigationLink'

import { companyStateNavigation, navigationLinks } from '../../helpers/navigationHelpers'
import styles from './styles'

/**
 *
 * @param {Object} props
 * @param {string} props.companySlug
 * @param {string} props.impersonatedHiringTeam
 * @param {string} props.companyState
 * @param {string} props.userRole
 * @param {function} props.signOut
 * @param {string} props.emailPreferencesAccessTokenKey
 * @param {number} props.unreadInterviewRequestCount
 */
const NavMenu = ({
  companySlug,
  impersonatedHiringTeam,
  companyState,
  userRole,
  signOut,
  emailPreferencesAccessTokenKey,
  unreadInterviewRequestCount,
}) => {
  const stateNavigation = companyStateNavigation({ companyState })
  const navLinkKeys = Object.keys(stateNavigation.navItems).filter(navItem => stateNavigation.navItems[navItem])
  const dropdownLinkKeys = Object.keys(stateNavigation.desktopDropdownItems).filter(
    navItem => stateNavigation.desktopDropdownItems[navItem],
  )
  const navigationLinkVariables = {
    companySlug,
    impersonatedHiringTeam,
    emailPreferencesAccessTokenKey,
    unreadInterviewRequestCount,
    companyState,
  }

  return (
    <ul className={styles.navigation}>
      <For each="navItem" of={navLinkKeys}>
        <With
          restrictUserRole={navigationLinks(navigationLinkVariables)[navItem]?.restrictUserRole}
          to={navigationLinks(navigationLinkVariables)[navItem]?.to}
          href={navigationLinks(navigationLinkVariables)[navItem]?.href}
          isActive={navigationLinks(navigationLinkVariables)[navItem]?.isActive}
          target={navigationLinks(navigationLinkVariables)[navItem]?.target}
          label={
            navigationLinks(navigationLinkVariables)[navItem]?.desktopLabel
              ? createElement(navigationLinks(navigationLinkVariables)[navItem].desktopLabel)
              : navigationLinks(navigationLinkVariables)[navItem]?.label
          }>
          {/*
            NavLinks
          */}
          <If condition={restrictUserRole !== userRole}>
            <li key={navItem}>
              <Choose>
                <When condition={navItem !== 'log_out'}>
                  <NavigationLink
                    to={to}
                    href={href}
                    isActive={isActive}
                    className={styles.link}
                    activeClassName={styles.activeLink}
                    target={target}>
                    {label}
                  </NavigationLink>
                </When>
                <Otherwise>
                  <button key={navItem} type="button" className={cx(styles.link, styles.navButton)} onClick={signOut}>
                    {label}
                  </button>
                </Otherwise>
              </Choose>
            </li>
          </If>
        </With>
      </For>
      <li>
        <NavDropdown className={styles.dropdown} label="More">
          <For each="dropItem" of={dropdownLinkKeys}>
            <With
              restrictUserRole={navigationLinks(navigationLinkVariables)[dropItem].restrictUserRole}
              to={navigationLinks(navigationLinkVariables)[dropItem].to}
              href={navigationLinks(navigationLinkVariables)[dropItem].href}
              target={navigationLinks(navigationLinkVariables)[dropItem].target}
              label={
                navigationLinks(navigationLinkVariables)[dropItem].desktopLabel
                  ? createElement(navigationLinks(navigationLinkVariables)[dropItem].desktopLabel)
                  : navigationLinks(navigationLinkVariables)[dropItem].label
              }>
              <Choose>
                <When condition={dropItem !== 'log_out'}>
                  <If condition={restrictUserRole !== userRole}>
                    <DropdownLink to={to} href={href} target={target} label={label} />
                  </If>
                </When>
                <Otherwise>
                  <DropdownButton label={label} onClick={signOut} />
                </Otherwise>
              </Choose>
            </With>
          </For>
        </NavDropdown>
      </li>
    </ul>
  )
}

export default NavMenu
